import pageApi from '@/apis/pageApi';
//Ajax-JSON函数
//强制为同步模式
import { Message } from 'view-design';
window.$msg = Message;
function AjaxJson(url, method, args, fn, dataType) {
  var obj = null;
  var ajax = new AjaxObject();
  ajax.URL = url;
  ajax.dataType = dataType;
  ajax.Method = method;
  ajax.Async = true;
  ajax.Args = args;
  ajax.onSuccess = function(xhr) {
    var text = xhr.responseText;
    if (text.charCodeAt() == 65279) text = text.substring(1); //处理utf8引导字节
    eval('obj=' + text);
    fn(obj);
  };
  ajax.onFailure = function(xhr) {
    eval("obj={Tag:'ERROR',Status:'" + xhr.status + "'}");
    fn(obj);
  };
  ajax.Connect();
  return obj;
}

//Ajax标准类模块
function AjaxObject() {
  this.URL = '';
  this.Method = 'GET';
  this.Async = true;
  this.Args = null;
  this.onSuccess = function() {};
  this.onFailure = function() {};
  /* eslint-disable */
  this.Request = window.XMLHttpRequest
    ? new XMLHttpRequest()
    : new ActiveXObject('Microsoft.XMLHTTP');
  this.Connect = function() {
    this.Method = this.Method.toUpperCase();
    if (this.Method == 'GET' && this.Args) {
      var args = '';
      if (typeof this.Args == 'object') {
        var arr = new Array();
        for (var k in this.Args) {
          var v = this.Args[k];
          arr.push(k + '=' + v);
        }
        args = arr.join('&');
      } else {
        // args = data; //alert("string");
      }
      this.URL += (this.URL && this.URL.indexOf('?') == -1 ? '?' : '&') + args;
      this.Args = null;
    }
    var q = this.Request;
    var evt1 = this.onSuccess;
    var evt2 = this.onFailure;
    var evt3 = this.onLoadend;
    this.Request.onreadystatechange = function() {
      _onStateChange(q, evt1, evt2, evt3);
    };

    this.Request.open(this.Method, this.URL, this.Async);
    if (this.Method == 'POST') {
      if (this.dataType == 'json') {
        this.Request.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
      } else {
        this.Request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded;');
      }
      let args = '';
      if (typeof this.Args == 'string') {
        args = this.Args;
      } else if (typeof this.Args == 'object') {
        if (this.dataType == 'json') {
          this.Args = JSON.stringify(this.Args);
        } else {
          let arr = new Array();
          for (let k in this.Args) {
            let v = this.Args[k];
            arr.push(k + '=' + v);
          }
          args = arr.join('&');
          this.Args = encodeURI(args);
        }
      }
    }
    try {
      this.Request.send(this.Args);
    } catch (e) {
      /* eslint-disable */
      console.log('connect exception.');
    }
  };

  function _onStateChange(xhr, success, failure) {
    if (xhr.readyState == 4) {
      var s = xhr.status;
      if (s == 0) {
        failure({
          Tag: 'error',
        });
      } else if (s >= 200 && s < 400) {
        success(xhr);
      } else {
        failure(xhr);
      }
    }
  }
}

class http {
  constructor() {}

  originPost(obj, fn) {
    if (obj.json !== undefined) {
      AjaxJson(obj.url, 'post', obj.json, fn, 'json');
    } else {
      AjaxJson(obj.url, 'post', obj.data, fn);
    }
  }
  originGet(obj, fn) {
    if (obj.json !== undefined) {
      AjaxJson(obj.url, 'get', obj.json, fn, 'json');
    } else {
      AjaxJson(obj.url, 'get', obj.data, fn);
    }
  }
  wrongCodeTest(data) {
    try {
      // 未登录拦截
      if (data.code == 80001) {
        return window.$APP.$router.push({
          path: pageApi.login.path,
        });
      }
      // 无权限
      if (data.code == 80002) {
        return window.$APP.$router.push({
          path: pageApi.home.path,
        });
      }
    } catch (err) {
      /* eslint-disable */
      console.log(err);
    }
  }
  post(obj) {
    return new Promise((resolve) => {
      this.originPost(obj, (res) => {
        this.wrongCodeTest(res);
        resolve(res);
      });
    }).catch((e) => {});
  }
  get(obj) {
    return new Promise((resolve) => {
      this.originGet(obj, (res) => {
        /* eslint-disable */
        try {
          this.wrongCodeTest(res);
        } catch {}
        resolve(res);
      });
    });
  }
  msgPost(obj) {
    return new Promise((resolve) => {
      this.originPost(obj, (res) => {
        this.wrongCodeTest(res);
        if (res.code == 200) {
          resolve(res);
        } else {
          window.$msg({
            message: res.msg,
            type: 'error',
            showClose: true,
          });
          resolve(res);
          // _Msg.error(res.msg)
        }
      });
    });
  }
  usualPost(obj) {
    return new Promise((resolve, reject) => {
      this.originPost(obj, (res) => {
        this.wrongCodeTest(res);
        if (res.code == 200) {
          resolve(res.data);
        } else {
          reject(res);
        }
      });
    });
  }
  jsonp({ url, dataObj, fn, err }) {
    var data = dataObj || [];
    var paraArr = [],
      paraString = ''; //get请求的参数。
    var urlArr;
    var callbackName; //每个回调函数一个名字。按时间戳。
    var script, head; //要生成script标签。head标签。
    var supportLoad; //是否支持 onload。是针对IE的兼容处理。
    var onEvent; //onload或onreadystatechange事件。
    var timeout = 5000 || 0; //超时功能。

    for (var i in data) {
      if (data.hasOwnProperty(i)) {
        paraArr.push(encodeURIComponent(i) + '=' + encodeURIComponent(data[i]));
      }
    }

    urlArr = url.split('?'); //链接中原有的参数。
    if (urlArr.length > 1) {
      paraArr.push(urlArr[1]);
    }

    callbackName = 'callback' + new Date().getTime();
    paraArr.push('callback=' + callbackName);
    paraString = paraArr.join('&');
    url = urlArr[0] + '?' + paraString;

    script = document.createElement('script');
    script.loaded = false; //为了实现IE下的onerror做的处理。JSONP的回调函数总是在script的onload事件（IE为onreadystatechange）之前就被调用了。因此我们在正向回调执行之时，为script标签添加一个属性，然后待到onload发生时，再检测有没有这个属性就可以判定是否请求成功，没有成功当然就调用我们的error。

    //将回调函数添加到全局。
    window[callbackName] = function(arg) {
      var callback = fn;
      callback(arg);
      script.loaded = true;
    };

    head = document.getElementsByTagName('head')[0];
    head.insertBefore(script, head.firstChild); //chrome下第二个参数不能为null
    script.src = url;

    supportLoad = 'onload' in script;
    onEvent = supportLoad ? 'onload' : 'onreadystatechange';

    script[onEvent] = function() {
      if (script.readyState && script.readyState != 'loaded') {
        return;
      }
      if (script.readyState == 'loaded' && script.loaded == false) {
        script.onerror();
        return;
      }
      //删除节点。
      script.parentNode &&
        script.parentNode.removeChild(script) &&
        head.removeNode &&
        head.removeNode(this);
      script = script[onEvent] = script.onerror = window[callbackName] = null;
    };

    script.onerror = function() {
      if (window[callbackName] == null) {
        /* eslint-disable */
        console.log('请求超时，请重试！');
      }
      err && err(); //如果有专门的error方法的话，就调用。
      script.parentNode &&
        script.parentNode.removeChild(script) &&
        head.removeNode &&
        head.removeNode(this);
      script = script[onEvent] = script.onerror = window[callbackName] = null;
    };

    if (timeout != 0) {
      setTimeout(function() {
        if (script && script.loaded == false) {
          window[callbackName] = null; //超时，且未加载结束，注销函数
          script.onerror();
        }
      }, timeout);
    }
  }
}

export default new http();
